import { Air, PrivacyTip, Public } from "@mui/icons-material"
import { Tooltip } from "@mui/material"

export const MyPrivateIcon = ({ is_private }) => {
    if (is_private) {
        return (
            <Tooltip arrow title="gara non pubblica" placement="right-start">

                <PrivacyTip color="error" />
            </Tooltip>
        )
    } else {
        return (
            <Tooltip arrow title="gara pubblica" placement="right-start">
                <Public color="success" />
            </Tooltip>
        )

    }
}



export const RunningMode = ({running}) => {
    if (running){
        return (
            <Tooltip arrow title="dati parziali pubblici" placement="right-start">
                <Air color="warning" />
            </Tooltip>

        )
    }else{
        return <></>
    }
}